import React, {useState} from 'react';
import Sidebar from '../sidebar/Sidebar';
import Header from '../Header';
import './MainLayout.css';
import Dashboard from '../../contents/dashboard/Dashboard';
import AbonneForm from '../../forms/AbonneForm';
import AdminForm from './../../forms/AdminForm';
import ServiceForm from './../../forms/ServiceForm';
import AdminTable from '../../TableData/AdminTable';
import ServiceTable from '../../TableData/ServiceTable';
import InstitutionDashboard from './../../institutions/InstitutionDashboard';
import AbonneDashboard from './../../abonnees/AbonneDashboard';
import Subscribers from '../../TableData/Subscribers';
import CategoriTable from './../../TableData/CategoriTable';
import CategorieForm from '../../forms/CategorieForm';
import PartnersTable from '../../TableData/PartnersTable';
import PartnersForm from '../../forms/PartnersForm';
import StructureTable from '../../TableData/StructureTable';
import StructureForm from '../../forms/StructureForm';
import CardsTable from '../../TableData/CardsTable';
import CarteForm from '../../forms/CarteForm';
import WarrantieTableExample from '../../TableData/WarrantieTableExample';
import Warranties from './../../TableData/Warranties';

function MainLayout() {
    const [selectedMenu, setSelectedMenu] = useState('dashboard');

    const renderContent = () => {
        switch (selectedMenu) {
          case 'dashboard':
            return <Dashboard />;
          case 'profile':
            return <h1>Page du Profil</h1>;
          case 'institutionsDash':
            return <InstitutionDashboard />; // Affiche le tableau des institutions
          case 'abonnesDash':
            return <AbonneDashboard />;
          case 'abonnes':
            return <AbonneForm />;
          case 'abonnesList':
            return <Subscribers />;
          case 'abonnesForm':
            return <AbonneForm />;
          case 'admins':
            return <AdminForm />;
          case 'adminsList':
            return <AdminTable />;
          case 'adminsForm':
            return <AdminForm />;
          case 'services':
            return <ServiceForm />;
          case 'servicesList':
            return <ServiceTable />;
          case 'servicesForm':
            return <ServiceForm />;
          case 'categorieList':
            return <CategoriTable />;
          case 'categorieForm':
            return <CategorieForm />;
          case 'partenaireList':
            return <PartnersTable />;
          case 'partenaireForm':
            return <PartnersForm />;
          case 'structureList':
            return <StructureTable />;
          case 'structureForm':
            return <StructureForm />;
          case 'carteList':
            return <CardsTable />;
          case 'carteForm':
            return <CarteForm />;
          case 'warrantieList':
            return <WarrantieTableExample />;
          case 'warrantieForm':
            return <Warranties />;  
          case 'auth':
            return <h1>Pages d'Authentification</h1>;
          default:
            return <h1>Bienvenue ! Sélectionnez un menu.</h1>;
        }
      };
    
  return (
    <div className="main-layout">
      <Sidebar onMenuSelect={setSelectedMenu} />
      <div className="content">
        <Header />
        {/* Placez ici le contenu principal de votre application */}
        <div className="main-content">
            {renderContent()}
        </div>
      </div>
    </div>
  )
}

export default MainLayout